// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HddTwoToneSvg from "@fishx/icons-svg/es/asn/HddTwoTone";
import FishxIcon from '../components/FishxIcon';

var HddTwoTone = function HddTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HddTwoToneSvg
  }));
};

HddTwoTone.displayName = 'HddTwoTone';
export default React.forwardRef(HddTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HddTwoTone.js
// module id = 2916
// module chunks = 0